import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const VideoBlockFragment: BlockFragment = {
  name: 'video',
  fragment: gql`
    fragment video on Video {
      id
      blockName
      blockType
      platform
      videoId
      videoMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Video {
      id
      blockName
      blockType
      platform
      videoId
      videoMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const VideoBlockType = 'video'

export interface VideoBlock extends BaseBlock {
  blockType: typeof VideoBlockType
  platform: string
  videoId: string
  videoMeta?: {
    viewableBy: [ViewableBy]
  }
}
